import { gsap } from 'gsap';

const desktop = window.matchMedia('(min-width: 64rem)');

export function psBackToTop() {
    const button = document.querySelector('[data-ps-back-to-top]');
    if (!button) return;

    const label = button.querySelector('.btn-label');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let shown = false;

    gsap.set(button, { scale: 0 });

    function update() {
        const top = window.scrollY;
        const total = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const next = total > 0 && top / total > 0.6 && total - top > 48;
        if (next === shown) return;
        shown = next;
        button.classList.toggle('pointer-events-none', !shown);
        button.toggleAttribute('inert', !shown);
        button.setAttribute('aria-hidden', shown ? 'false' : 'true');
        const motion = { scale: shown ? 1 : 0, duration: reduce ? 0 : 0.45, ease: 'power3.out' };
        if (!shown) { motion.x = 0; motion.y = 0; }
        gsap.to(button, motion);
        if (!shown && label) gsap.to(label, { x: 0, y: 0, duration: reduce ? 0 : 0.3, ease: 'power3.out' });
    }

    document.addEventListener('scroll', update, { passive: true });
    update();

    button.addEventListener('click', () => {
        document.documentElement.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    if (reduce || !label) return;

    const strength = 0.4;

    desktop.addEventListener('change', () => {
        if (desktop.matches) return;
        gsap.to(button, { x: 0, y: 0, scale: shown ? 1 : 0, duration: 0.3, ease: 'power3.out' });
        gsap.to(label, { x: 0, y: 0, duration: 0.3, ease: 'power3.out' });
    });

    button.addEventListener('mousemove', (event) => {
        if (!shown || !desktop.matches) return;
        const rect = button.getBoundingClientRect();
        const x = event.clientX - rect.left - rect.width / 2;
        const y = event.clientY - rect.top - rect.height / 2;
        gsap.to(button, { x: x * strength, y: y * strength, scale: 1, duration: 0.4, ease: 'power3.out' });
        gsap.to(label, { x: x * strength * 0.4, y: y * strength * 0.4, duration: 0.4, ease: 'power3.out' });
    });

    button.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        gsap.to(button, { x: 0, y: 0, scale: shown ? 1 : 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
        gsap.to(label, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' });
    });
}
